export default x => () => x;



//////////////////
// WEBPACK FOOTER
// ./~/d3-contour/src/constant.js
// module id = 172
// module chunks = 0